import * as React from 'react';
import { Redirect } from 'react-router-dom';
import * as $ from 'jquery';
import * as classNames from 'classnames';
import Loader from '../shared/loader';
import { pick, isEmpty } from 'lodash';
import colors from '../shared/colors';
import { getCurrency, getLocale } from '../services/format.currency';

export default class extends React.Component<
  { accounts; setSettings; history },
  {
    locale: string;
    currency: string;
    loading: boolean;
    shuffle: boolean;
  }
> {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = this.getSettings(props.user);
  }

  componentDidUpdate() {
    $('select').material_select();
  }

  getSettings(user = {} as any) {
    const { settings: { locale = getLocale(), currency = getCurrency(), shuffle = false } = {} } = user;
    return { locale, currency, loading: false, shuffle };
  }

  componentWillReceiveProps(nextProps) {
    const { user } = nextProps;
    this.setState(this.getSettings(user));
  }

  componentDidMount() {
    $('select').material_select();
    $('input#locale').autocomplete({
      data:
        navigator &&
        navigator.languages.reduce((aggr, v) => {
          aggr[v] = null;
          return aggr;
        }, {}),
      limit: 20, // The max amount of results that can be shown at once. Default: Infinity.
      onAutocomplete: value => {
        this.handleChange('locale')({ target: { value } });
        // Callback function when value is autcompleted.
      },
      minLength: 1 // The minimum length of the input for the autocomplete to start. Default: 1.
    });
    $('input#currency').autocomplete({
      data: {
        EUR: null,
        USD: null,
        GBP: null
      },
      limit: 20, // The max amount of results that can be shown at once. Default: Infinity.
      onAutocomplete: value => {
        this.handleChange('currency')({ target: { value } });
        // Callback function when value is autcompleted.
      },
      minLength: 1 // The minimum length of the input for the autocomplete to start. Default: 1.
    });
  }

  handleChange(el) {
    return event => {
      this.setState({ [el]: event.target.value });
    };
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.setState({ loading: true });
    const model = pick(this.state, ['locale', 'currency', 'shuffle']);
    await this.props.setSettings(model);
    this.props.history.push('/dashboard');
  }

  render() {
    if (this.state.loading) {
      return <Loader />;
    }
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div className="row">
            <div className="col s2" />
            <div className="input-field col s8">
              <label className={classNames({ active: !!this.state.locale })} htmlFor="locale">
                Locale
              </label>
              <input
                type="text"
                value={this.state.locale}
                onChange={this.handleChange('locale')}
                id="locale"
                required
                className="validate"
              />
            </div>
            <div className="col s2" />
          </div>

          <div className="row">
            <div className="col s2" />
            <div className="input-field col s8">
              <label className={classNames({ active: !!this.state.currency })} htmlFor="currency">
                Currency
              </label>
              <input
                type="text"
                id="currency"
                required
                className="validate"
                value={this.state.currency}
                onChange={this.handleChange('currency')}
              />
            </div>
            <div className=" col s2" />
          </div>

          <div className="row">
            <div className="col s2" />
            <div className="col s8">
              <input
                type="checkbox"
                id="shuffle"
                checked={this.state.shuffle}
                onChange={() => this.setState({ shuffle: !this.state.shuffle })}
              />
              <label htmlFor="shuffle">
                <span>Shuffle values</span>
              </label>
            </div>
          </div>

          <div className="fixed-action-btn">
            <div className="center-align">
              <button type="submit" className="btn-floating btn-large waves-effect waves-light light-blue darken-3">
                <i className="material-icons">done</i>
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/settings/component.tsx